import { render, staticRenderFns } from "./document-debug.vue?vue&type=template&id=130e6730&"
import script from "./document-debug.vue?vue&type=script&lang=js&"
export * from "./document-debug.vue?vue&type=script&lang=js&"
import style0 from "./document-debug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports